import { yupResolver } from '@hookform/resolvers/yup'
import { useGrupoUsuariosEdicaoQueryHandler } from './use-query-handler'
import { validationSchema } from '../utils/forms'
import { GrupoUsuariosEdicaoProps } from '../ui/grupo-usuarios-edicao'
import { SubmitHandler, useForm, useWatch } from 'react-hook-form'
import { useEffect } from 'react'
import { OptionSelect } from '@/core/utils/types'
import {
  GetGrupoUsuariosQueryQuery,
  GrupoUsuariosInput
} from '@/core/types/graphql'
import { useInitialValues } from './use-initial-values'
import { formatGroup } from '../utils/functions'
import { useQueryClient } from '@tanstack/react-query'
import { request } from '../../../core/utils/request'

export interface GrupoUsuariosValues {
  id: string
  nome: string
  nomeOriginal: string
  active: boolean
  possuiCargos: boolean
  possuiGrupos: boolean
  possuiPerfil: boolean
  possuiSetores: boolean
  possuiUsuariosManuais: boolean
  possuiDepartamentos: boolean
  cargos?: OptionSelect[]
  criador: GetGrupoUsuariosQueryQuery['grupoUsuarios']['criador']
  dealers?: OptionSelect[]
  grupos?: OptionSelect[]
  marcas?: OptionSelect[]
  publico: boolean
  departamentos?: OptionSelect[]
  setores?: OptionSelect[]
  tipo: string
  tiposAcesso?: OptionSelect[]
  tiposUsuarios?: OptionSelect[]
  todosDealers: boolean
  usuariosManuais?: OptionSelect[]
}

export const useGrupoUsuariosEdicaoForm = ({
  handleCloseDialog,
  onClose,
  onOpen,
  isModal
}: GrupoUsuariosEdicaoProps) => {
  const client = useQueryClient()
  const {
    getGrupoUsuariosQuery,
    getGrupoUsuariosDominioQuery,
    salvarGrupoUsuarios
  } = useGrupoUsuariosEdicaoQueryHandler()

  const { data: { grupoUsuarios } = {}, isLoading: loadingGrupo } =
    getGrupoUsuariosQuery
  const { data: { dealers, usuarioLogado } = {} } = getGrupoUsuariosDominioQuery

  const { initialValues } = useInitialValues({
    dealers,
    grupoUsuarios,
    usuarioLogado
  })

  const form = useForm<GrupoUsuariosValues>({
    values: initialValues,
    resolver: yupResolver(validationSchema(client)),
    mode: 'all'
  })

  const values = useWatch({ control: form.control })

  const submitGroup: SubmitHandler<GrupoUsuariosValues> = async data => {
    if (isModal) {
      onClose?.()
    }
    const grupoUsuariosInput: GrupoUsuariosInput = formatGroup({
      grupoUsuarios: data,
      usuarioLogado
    })
    salvarGrupoUsuarios({
      grupoUsuariosInput,
      resetForm: form.reset,
      onOpen: isModal ? onOpen : undefined,
      onAskUserConfirm: grupo => {
        if (isModal && handleCloseDialog) {
          handleCloseDialog({
            value: grupo?.id?.toString(),
            label: grupo?.nome
          })
        }
      }
    })
  }

  return {
    form,
    values,
    submitGroup,
    loadingGrupo
  }
}
